import React from 'react'
import { Stack } from '@mui/material'
import { SectionLabel } from 'components/UI/SectionLabel'
import { UseFormReturn } from 'react-hook-form'
import { FieldRow } from 'components/Fields/FieldRow'

interface FormValues {
  first_name: string
  last_name: string
  username: string | null
  birthday: Date | null
  phone: string | null
  country: string | null
  gender: string | null
  email: string | null
  current_password?: string
  new_password?: string
}

interface LoginInfoProps {
  methods: UseFormReturn<FormValues>
  onEditField: (field: { key: keyof FormValues | 'password' | 'name'; title: string }) => void
}

/**
 * VERA-291 — the pending-confirmation banner (+ "Undo") this used to render
 * was for the old, backend-no-op email flow, which faked an async
 * "confirmation email sent, using your old address until you confirm"
 * state. EditEmailDrawer now confirms the change with an inline OTP code, so
 * by the time a change reaches here it has already succeeded — there is no
 * pending state left to show or undo.
 */
export const LoginInfo: React.FC<LoginInfoProps> = ({ methods, onEditField }) => {
  const email = methods.watch('email')

  return (
    <Stack mb={4}>
      <SectionLabel>Log in</SectionLabel>

      <Stack spacing={0}>
        <FieldRow
          label="Email"
          value={email as string}
          placeholder="Add email"
          onClick={() => onEditField({ key: 'email', title: 'Edit email' })}
        />

        <FieldRow
          label="Password"
          masked
          onClick={() => onEditField({ key: 'password', title: 'Edit password' })}
        />
      </Stack>
    </Stack>
  )
}
